<template>
  <section class="stores">
    <div v-if="HCO_IF == 'CK' && request_list != ''" style="margin-bottom: 10px">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <!-- <h1 style="font-size: 20px"></h1> -->
        <p class="P_XT" style="">审批详情</p>
        <!-- <p style="font-size: 14px">
        申请类型：{{approval_request_GetReason_text.approval_type == 'store'?
        '门店新增':approval_request_GetReason_text.approval_type == 'ClaimStore'?
        '门店认领':approval_request_GetReason_text.approval_type == 'store_edit'?
        '门店编辑':approval_request_GetReason_text.approval_type == 'store_astig'?
        '门店编辑':approval_request_GetReason_text.approval_type == 'store_try'?'门店编辑':''}} 申请人：{{ request_list_username }}
      </p> -->
        <el-steps :space="400" :active="num_zt" finish-status="success">
          <el-step
            v-for="(item, index) in request_list.ApprovalDataInfoList"
            :key="index"
            :status="item.adireason == '-1' ? 'error' : ''"
            :title="item.uername"
            :description="
              item.adireason == 0
                ? '(已审批)' + (item.date != null ? item.date : '')
                : item.adireason == 1
                ? '(未审批)' + (item.date != null ? item.date : '')
                : item.adireason == -1
                ? '(已驳回)' + (item.date != null ? item.date : '')
                : item.adireason == 2
                ? '(待审批)' + (item.date != null ? item.date : '')
                : ''
            "
          ></el-step>
        </el-steps>
        <div v-if="request_list.isadmin && SP_IF == 'SP'">
          <el-alert title="请在下方补充信息" style="margin-top: 20px" type="warning"></el-alert>
          <br />
          <div class="demo-input-suffix">
            <span style="color: red">*</span>
            ZCN 编号
            <el-input v-model="approval_request_Put_Material_list.data.BWAcctNumber" style="width: 250px" placeholder="请输入"></el-input>
          </div>
        </div>
        <el-alert
          v-if="description_text != ''"
          title="驳回理由"
          type="error"
          style="margin-top: 20px"
          :description="description_text"
          :closable="false"
          show-icon
        ></el-alert>
        <div v-if="SP_IF == 'SP'" style="margin-top: 20px; margin-bottom: 20px">
          <el-button type="success" @click="submit_approvals()">同 意</el-button>
          <el-button type="danger" @click="dialogVisible = true">驳 回</el-button>
        </div>
        <!-- <el-divider></el-divider> -->
      </div>
    </div>
    <el-form ref="form" :model="form" key="form" :rules="editFormRules" label-width="180px" label-position="left">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <p class="P_XT" style="">医院基本信息</p>
        <el-row v-if="form.BWAcctNumber">
          <el-col :span="7" :xs="24">
            <el-form-item label="ZCN 编号" prop="Name">
              <el-input :disabled="true" v-model="form.BWAcctNumber" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="医院名称" prop="Name">
              <el-input @input="fapiao_blur($event)" :disabled="HCO_IF == 'CK'" v-model="form.Name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Name !== form.Name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Name ? '空' : old_value.Name }}
          </el-col>
        </el-row>
        <el-row v-if="HCO_IF == 'CK' || HCO_IF == 'EDIT'">
          <el-col :span="7" :xs="24">
            <el-form-item label="医院曾用名" prop="original_name">
              <el-input :disabled="true" v-model="form.original_name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.original_name != form.original_name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.original_name ? '空' : old_value.original_name }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="医院地址" prop="Address">
              <el-input :disabled="HCO_IF == 'CK' || !BCXX_IF" v-model="form.Address" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Address != form.Address" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Address ? '空' : old_value.Address }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="省份名称" prop="province_name">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.province_name" placeholder="请输入"></el-input> -->
              <el-select :disabled="HCO_IF == 'CK' || !BCXX_IF" v-model="form.province_name" @change="province_change($event)" placeholder="请选择">
                <el-option v-for="item in region_list" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.ProvinceID != form.ProvinceID" :span="4" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{
              !old_value.ProvinceID
                ? '空'
                : region_list.find((item) => {
                    return item.id == old_value.ProvinceID
                  }).name
            }}
            <!-- <el-select disabled='true' v-model="old_value.province_name" @change="province_change($event)" placeholder="空">
                <el-option
                v-for="item in region_list"
                :key="item.id"
                :label="item.name"
                :value="item.name">
                </el-option>
            </el-select> -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="城市名称" prop="city_name">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.city_name" placeholder="请输入"></el-input> -->
              <el-select :disabled="HCO_IF == 'CK' || !BCXX_IF" v-model="form.city_name" @change="city_change($event)" placeholder="请选择">
                <el-option v-for="item in city_list" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="
              OLD_IF &&
              old_value.cityid != form.cityid &&
              old_value.cityid != 110100 &&
              old_value.cityid != 310100 &&
              old_value.cityid != 120100 &&
              old_value.cityid != 500100 &&
              old_value.cityid != 500200
            "
            :span="7"
            :xs="24"
            class="yz_cls"
          >
            {{ old_value_titile }}：{{
              !old_value.cityid
                ? '空'
                : region_list
                    .find((item) => {
                      return item.id === old_value.ProvinceID
                    })
                    .children.find((item) => {
                      return item.id == old_value.cityid
                    }).name
            }}
          </el-col>
          <!-- <el-col :span="7" :xs="24">
          <el-form-item label="城市" prop="cityid">
            <el-select :disabled='HCO_IF == "CK"' v-model="form.cityid" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="公私立" prop="is_private">
              <el-select
                :disabled="HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)"
                v-model="form.is_private"
                clearable
                placeholder="请输入"
              >
                <el-option label="公立" :value="false"></el-option>
                <el-option label="私立" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.is_private != form.is_private" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.is_private ? '空' : old_value.is_private ? '私立' : '公立' }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="类型" prop="Category">
              <el-select :disabled="HCO_IF == 'CK' || !BCXX_IF" v-model="form.Category" clearable placeholder="请输入">
                <el-option v-for="item in level_list" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Category != form.Category" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Category ? '空' : old_value.Category }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="级别" prop="level">
              <el-select :disabled="HCO_IF == 'CK' || !BCXX_IF" filterable v-model="form.level" clearable placeholder="请输入">
                <el-option label="一级" value="一级"></el-option>
                <el-option label="二级" value="二级"></el-option>
                <el-option label="三级" value="三级"></el-option>
                <el-option label="未定级" value="未定级"></el-option>
                <el-option label="未知" value="未知"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.level != form.level" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.level ? '空' : old_value.level }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="发票名称" prop="">
              <el-input :disabled="HCO_IF == 'CK'" v-model="form.invoice_name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.invoice_name != form.invoice_name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.invoice_name ? '空' : old_value.invoice_name }}
          </el-col>
        </el-row>
      </div>
      <div style="background-color: white; padding: 30px; border-radius: 10px; margin-top: 10px">
        <p class="P_XT" style="">医院补充信息</p>
        <el-row>
          <div v-if="BU_IF_REF_CAT">
            <el-col :span="9" :xs="24">
              <el-form-item label="屈光眼表大区/小区" prop="ref_sales_region_small">
                <!-- <el-select :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.sales_region_small" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
                <el-cascader
                  :disabled="(HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)) && BCXX_IF"
                  v-model="form.ref_large_small"
                  :options="Employee_list"
                  style="width: 250px"
                  clearable
                  :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
                  @change="ref_large_small_change"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col
              v-if="OLD_IF && old_value.ref_sales_region_list.toString() != form.ref_sales_region_list.toString()"
              :span="7"
              :xs="24"
              class="yz_cls"
              style="position: relative; padding-top: 0; padding-left: 70px; box-sizing: border-box"
            >
              <span class="yz_cls" style="position: absolute; left: 0; top: 0">{{ old_value_titile }}：</span>
              <el-cascader
                disabled="true"
                v-model="old_value.ref_sales_region_list"
                :options="Employee_list"
                style="width: 250px; display: inline-block"
                clearable
                :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
                @change="ref_large_small_change"
              ></el-cascader>
            </el-col>
          </div>
        </el-row>
        <el-row>
          <div v-if="BU_IF_REF_CAT">
            <el-col :span="9" :xs="24">
              <el-form-item label="飞白大区/小区" prop="cat_sales_region_small">
                <!-- <el-select :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.sales_region_small" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
                <el-cascader
                  :disabled="(HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)) && BCXX_IF"
                  v-model="form.cat_large_small"
                  :options="Employee_list"
                  style="width: 250px"
                  clearable
                  :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
                  @change="cat_large_small_change"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col
              v-if="OLD_IF && old_value.cat_sales_region_list.toString() != form.cat_sales_region_list.toString()"
              :span="7"
              :xs="24"
              class="yz_cls"
              style="position: relative; padding-top: 0; padding-left: 70px; box-sizing: border-box"
            >
              <span class="yz_cls" style="position: absolute; left: 0; top: 0">{{ old_value_titile }}：</span>
              <el-cascader
                disabled="true"
                v-model="old_value.cat_sales_region_list"
                :options="Employee_list"
                style="width: 250px; display: inline-block"
                clearable
                :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
                @change="cat_large_small_change"
              ></el-cascader>
            </el-col>
          </div>
        </el-row>
        <el-row>
          <div v-if="BU_IF_SB_JT">
            <el-col :span="9" :xs="24">
              <el-form-item label="大区/小区" :prop="HCO_IF != 'EDIT' ? 'sales_region_small' : 'sales_region_small_no'">
                <!-- <el-select :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.sales_region_small" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
                <el-cascader
                  :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                  v-model="form.large_small"
                  :options="Employee_list"
                  style="width: 250px"
                  clearable
                  :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
                  @change="large_small_change"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col
              v-if="OLD_IF && old_value.RIDList.toString() != form.RIDList.toString()"
              :span="7"
              :xs="24"
              class="yz_cls"
              style="position: relative; padding-top: 0; padding-left: 70px; box-sizing: border-box"
            >
              <span class="yz_cls" style="position: absolute; left: 0; top: 0">{{ old_value_titile }}：</span>
              <el-cascader
                disabled="true"
                v-model="old_value.RIDList"
                :options="Employee_list"
                style="width: 250px; display: inline-block"
                clearable
                :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
                @change="large_small_change"
              ></el-cascader>
            </el-col>
          </div>
        </el-row>
        <el-row v-if="BU_IF_SB_JT">
          <el-col :span="7" :xs="24">
            <el-form-item label="晶体销售岗位号" :required="true">
              <!-- <el-select :disabled='HCO_IF == "CK"' v-model="form.crystal_position_code" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.crystal_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select1"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.crystal_position_code != form.crystal_position_code" :span="7" :xs="24" class="yz_cls">
            {{old_value_titile}}：{{ !old_value.crystal_position_code?'空':old_value.crystal_position_code }}
          </el-col> -->
        </el-row>
        <el-row v-if="BU_IF_REF_CAT">
          <el-col :span="7" :xs="24">
            <el-form-item label="超乳销售经理岗位号" :required="true">
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.phaco_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select2"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="BU_IF_REF_CAT">
          <el-col :span="7" :xs="24">
            <el-form-item label="飞白术士发展岗位号" :required="true">
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.cdhc_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select2"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row v-if="BU_IF_REF_CAT">
          <el-col :span="7" :xs="24">
            <el-form-item label="CD临床应用发展岗位号" :required="true">
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.facility_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select2"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="BU_IF_REF_CAT">
          <el-col :span="7" :xs="24">
            <el-form-item label="PPD先进术式发展岗位号" :required="true">
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.pd_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select2"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row v-if="BU_IF_REF_CAT">
          <el-col :span="7" :xs="24">
            <el-form-item label="REF销售岗位号" :required="true">
              <!-- <el-select :disabled='HCO_IF == "CK"' v-model="form.ref_crrstal_position_code_string" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.ref_crystal_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select3"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.ref_crystal_position_code != form.ref_crystal_position_code" :span="7" :xs="24" class="yz_cls">
            {{old_value_titile}}：{{ !old_value.ref_crystal_position_code?'空':old_value.ref_crystal_position_code }}
          </el-col> -->
        </el-row>
        <el-row v-if="BU_IF_REF_CAT">
          <el-col :span="7" :xs="24">
            <el-form-item label="飞白设备销售岗位号" :required="true">
              <!-- <el-select :disabled='HCO_IF == "CK"' v-model="form.cat_crystal_position_code_string" clearable placeholder="请输入">
              <el-option label="11" :value="1"></el-option>
            </el-select> -->
              <el-select
                :disabled="(HCO_IF == 'CK' || HCO_IF == 'EDIT') && BCXX_IF"
                v-model="form.cat_crystal_position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                ref="select"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="(item, index) in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.cat_crystal_position_code != form.cat_crystal_position_code" :span="7" :xs="24" class="yz_cls">
            {{old_value_titile}}：{{ !old_value.cat_crystal_position_code?'空':old_value.cat_crystal_position_code }}
          </el-col> -->
        </el-row>
        <el-row v-if="(BU_IF == '晶体事业部' || HCO_IF == 'CK') && form.is_private">
          <el-col :span="7" :xs="24">
            <el-form-item label="白内障私立集团" :prop="HCO_IF == 'ADD' ? 'cat_Group' : ''">
              <el-select :disabled="HCO_IF != 'ADD'" @change="cat_Group_change($event)" v-model="form.cat_Group" placeholder="请选择">
                <el-option v-for="item in CatGroup_list" :key="item.ID" :label="item.ShowName" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="(BU_IF == '飞秒激光及眼表事业部' || HCO_IF == 'CK') && form.is_private">
          <el-col :span="7" :xs="24">
            <el-form-item label="屈光飞白私立医院集团" prop="ref_Group" key="ref_Group">
              <!-- <el-input :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.ref_Group" placeholder="请输入"></el-input> -->
              <el-select
                :disabled="HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)"
                @change="ref_Group_change($event)"
                v-model="form.ref_Group"
                placeholder="请选择"
              >
                <el-option v-for="item in RefGroup_list" :key="item.ID" :label="item.ShowName" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.RefGroup_list != form.RefGroup_list" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.RefGroup_list ? '空' : old_value.RefGroup_list }}
          </el-col>
        </el-row>
        <el-row v-if="BU_IF == '飞秒激光及眼表事业部' || HCO_IF == 'CK'">
          <el-col :span="7" :xs="24">
            <el-form-item label="屈光飞白医院类型" prop="ref_hco_type ">
              <!-- <el-input :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.ref_Group" placeholder="请输入"></el-input> -->
              <el-select
                :disabled="(HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)) && BCXX_IF"
                v-model="form.ref_hco_type"
                placeholder="请选择"
              >
                <el-option label="公立医院" value="公立医院"></el-option>
                <el-option label="私立医院" value="私立医院"></el-option>
                <el-option label="新兴市场" value="新兴市场"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.ref_hco_type != form.ref_hco_type" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.ref_hco_type ? '空' : old_value.ref_hco_type }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="统一社会信用代码">
              <el-input
                :disabled="HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)"
                v-model="form.GB32100_2015"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.GB32100_2015 != form.GB32100_2015" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.GB32100_2015 ? '空' : old_value.GB32100_2015 }}
          </el-col>
        </el-row>
        <!-- <el-row>
        <el-col :span="7" :xs="24">
          <el-form-item label="执业范围是否包含眼科" >
            <el-select :disabled='HCO_IF == "CK" || HCO_IF == "EDIT"' v-model="form.IsContainsEyes" clearable placeholder="请输入">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="执业许可截止日期">
              <el-date-picker
                :disabled="HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)"
                v-model="form.license_life"
                type="date"
                placeholder="请输入"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.license_life != form.license_life" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.license_life ? '空' : old_value.license_life }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="营业许可截止日期">
              <el-date-picker
                :disabled="HCO_IF == 'CK' || (HCO_IF == 'EDIT' && form.BWAcctNumber)"
                v-model="form.business_life"
                type="date"
                placeholder="请输入"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.business_life != form.business_life" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.business_life ? '空' : old_value.business_life }}
          </el-col>
        </el-row>
        <!-- <el-form-item label="证明文件">
        <el-upload v-if="HCO_IF != 'CK'" style="display: inline-block; margin-right: 20px" class="upload-demo" ref="upload" action="/images/Upload/Flie" :show-file-list="true"
          :headers="token" :on-success="handleSuccess" :before-upload="handlebefore" :on-error="handonerror" :file-list="fileList" limit="9">
          <el-button type="primary">上传</el-button>
        </el-upload>
        <el-button @click="btn_up_2(form.file_urls)" v-if="form.file_urls" type="primary">预览</el-button>
      </el-form-item> -->
        <!-- <el-row> -->

        <el-row>
          <el-col :span="24">
            <el-form-item label="证明文件">
              <el-upload
                v-if="HCO_IF != 'CK'"
                action="/images/Upload/Flie"
                ref="upload_img"
                :headers="token"
                :on-success="handleSuccess"
                :before-upload="handlebefore"
                :before-remove="beforeRemove"
                :on-error="handonerror"
                multiple
                :file-list="fileList"
                :show-file-list="false"
              >
                <el-button type="primary">上传</el-button>
              </el-upload>
              <!-- <el-button @click="btn_up_1"  v-if="form.files" type="primary">下载</el-button> -->
              <!-- <el-button   v-if="form.files" @click="btn_up_1_yl(form.files)" type="primary">预览</el-button> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-left: 180px">
          <div v-for="fit in file_ist" :key="fit" style="display: inline-block; margin-right: 5px; position: relative">
            <!-- <span class="demonstration">{{ fit }}</span> -->
            <el-image style="width: 100px; height: 100px" :src="'https://share.51i.cc/' + fit" :fit="fit">
              <div slot="error" class="image-slot">
                <el-image style="width: 100px; height: 100px" src="https://jnjh5.oss-cn-beijing.aliyuncs.com/masterdata/wj.png" :fit="fit"></el-image>
              </div>
            </el-image>
            <div
              style="
                font-size: 19px;
                position: absolute;
                top: 0px;
                left: 1px;
                color: white;
                width: 100px;
                height: 20px;
                background-color: rgba(0, 0, 0, 0.5);
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
              "
            >
              <i v-if="HCO_IF != 'CK'" style="float: right; cursor: pointer" @click="btn_clear_img(fit)" class="el-icon-close"></i>
              <!-- <i  style="float:left;cursor:pointer;"  @click="btn_up_1_yl(fit)"  class="el-icon-download"></i> -->
              <i style="float: left; cursor: pointer" @click="btn_up_1_yl(fit)" class="el-icon-zoom-in"></i>
            </div>
          </div>
          <div
            v-if="OLD_IF && old_value.file_urls !== form.file_urls"
            style="display: inline-block; position: relative; padding-left: 70px; box-sizing: border-box; min-width: 100px; min-height: 100px"
          >
            <span style="position: absolute; top: -10px; left: 0" class="yz_cls">{{ old_value_titile }}：{{ !old_value.file_urls ? '空' : '' }}</span>
            <div
              v-if="old_value.file_urls"
              v-for="fit in file_urls_list"
              :key="fit"
              style="display: inline-block; margin-right: 5px; position: relative"
            >
              <el-image style="width: 100px; height: 100px" :src="'https://share.51i.cc/' + fit" :fit="fit">
                <div slot="error" class="image-slot">
                  <el-image
                    style="width: 100px; height: 100px"
                    src="https://jnjh5.oss-cn-beijing.aliyuncs.com/masterdata/wj.png"
                    :fit="fit"
                  ></el-image>
                </div>
              </el-image>
              <div
                style="
                  font-size: 19px;
                  position: absolute;
                  top: 0px;
                  left: 1px;
                  color: white;
                  width: 100px;
                  height: 20px;
                  background-color: rgba(0, 0, 0, 0.5);
                  border-top-left-radius: 5px;
                  border-top-right-radius: 5px;
                "
              >
                <!-- <i v-if="TRYON_DETILS_IF != 'CKSQ'" style="float:right;cursor:pointer;" @click="btn_clear_img(fit)" class="el-icon-close"></i> -->
                <i style="float: left; cursor: pointer" @click="btn_up_1_yl(fit)" class="el-icon-zoom-in"></i>
              </div>
            </div>
          </div>
        </el-row>
        <!-- </el-row> -->
        <el-row v-if="HCO_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="Key Account" prop="KEYACCOUNT">
              <el-select :disabled="!GLY_IF" v-model="form.KEYACCOUNT" clearable placeholder="请输入">
                <el-option label="Key 300" value="Key 300"></el-option>
                <el-option label="Next 500" value="Next 500"></el-option>
                <el-option label="Others" value="Others"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.KEYACCOUNT != form.KEYACCOUNT" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.KEYACCOUNT ? '空' : old_value.KEYACCOUNT }}
          </el-col>
        </el-row>
        <el-row v-if="HCO_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="停用" prop="HCO_Status">
              <el-select :disabled="!GLY_IF" v-model="form.HCO_Status" clearable placeholder="请输入">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.HCO_Status != form.HCO_Status" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.HCO_Status ? '空' : old_value.HCO_Status }}
          </el-col>
        </el-row>
        <el-row v-if="HCO_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="删除/合并" prop="HCO_Status">
              <el-select :disabled="HBSC_IF" v-model="form.Del_Merge" clearable placeholder="请输入">
                <el-option label="合并" value="合并"></el-option>
                <el-option label="删除" value="删除"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Del_Merge != form.Del_Merge" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Del_Merge ? '空' : old_value.Del_Merge }}
          </el-col>
        </el-row>
        <el-row v-if="HCO_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="备注" prop="HCO_Status">
              <el-input :disabled="HBSC_IF && BCXX_IF" type="textarea" v-model="form.remark" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.remark != form.remark" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.remark ? '空' : old_value.remark }}
          </el-col>
        </el-row>
        <el-button @click="save('form')" v-if="HCO_IF != 'CK'" v-preventReClick="3000" type="primary">保 存</el-button>
        <el-button @click="save2('form')" v-if="HBSC_IF == false" v-preventReClick="3000" type="primary">保 存</el-button>
        <el-button @click="onBack()">返回</el-button>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible_img">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-input type="textarea" v-model="approval_request_Put_Material_list.reason"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="turn_approvals()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  HcoGetByid,
  HcoAddHCO,
  HcoUpdataHCO,
  approval_requestGetApprovalInfoByID,
  HcoApproval,
  HcoHcoExportExcel,
  regionGetRegionTree,
  EmployeePosition_QueryList,
  EmployeeRegionGetEmployeeRegionTrees,
  Employee_GetCurrentEmployee,
  HcoGetHcoCatGroup,
  HcoGetHcoRefGroup,
  HcoUpdataHCOTagInfo,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      FPC_IF: false,
      file_urls_list: [],
      file_ist: [],
      hideUpload: true,
      ImageUrlArray: [],
      dialogImageUrl: '',
      dialogVisible_img: false,
      zmwj_img: [],
      OLD_IF: false,
      old_value: {},
      old_value_titile: '原值',
      BCXX_IF: true,
      BU_IF_SB_JT: true,
      BU_IF_REF_CAT: true,
      level_list: [
        '综合医院',
        '中医医院',
        '耳鼻喉科医院',
        '中西医结合医院',
        '眼科医院',
        '精神病医院',
        '妇幼保健院(所、站)',
        '卫生院',
        '康复医院',
        '民族医院',
        '骨科医院',
        '社区卫生服务中心(站)',
        '专科疾病防治院(所、站)',
        '儿童医院',
        '门诊部(所)',
        '心血管病医院',
        '其他',
        '传染病医院',
        '肿瘤医院',
        '口腔医院',
        '其他专科医院',
        '其他医疗机构',
        '美容医院',
        '结核病医院',
        '村卫生室',
        '疗养院',
        '采供血机构',
        '疾病预防控制中心(防疫站)',
        '麻风病医院',
        '皮肤病医院',
        '胸科医院',
        '血液病医院',
        '整形外科医院',
        '职业病医院',
      ],
      GLY_IF: false,
      HBSC_IF: true,
      CatGroup_list: [],
      RefGroup_list: [],
      BU_IF: false,
      UPLOAD_IF: false,
      Employee_list: [],
      city_list: [],
      region_list: [],
      fileList: [],

      crystal_position_code_options: [],
      approval_request_Put_Material_list: {
        approval_data_id: this.$route.query.approval_data_id,
        type: '已通过',
        state: 0,
        approvalstate: false,
        description: '',
        data: {
          BWAcctNumber: '',
          ID: this.$route.query.id,
        },
      },
      dialogVisible: false,
      Sales_analytics_msg: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      HCO_IF: this.$route.query.type,
      SP_IF: this.$route.query.status,
      token: {},
      form: {
        name: '',
        file_urls: '',
        filecrystal_position_code_urls: '',
        facility_position_code: '',
        cat_crystal_position_code: '',
        pd_position_code: '',
        phaco_position_code: '',
        cdhc_position_code: '',
        filref_crystal_position_codee_urls: '',
        large_small: [],
        cat_large_small: [],
        ref_large_small: [],
        city_name: '',
        city_id: '',
        // filref_crystal_position_codee_urls:[],
        invoice_name: '',
      },
      editFormRules: {
        BWAccthunber: [{ required: true, message: '请填写', trigger: 'blur' }],
        Name: [{ required: true, message: '请填写', trigger: 'blur' }],
        // Nane: [{ required: true, message: '请选择', trigger: 'blur' }],
        invoice_name: [{ required: true, message: '请填写', trigger: 'blur' }],
        Address: [{ required: true, message: '请填写', trigger: 'blur' }],
        city_name: [{ required: true, message: '请填写', trigger: 'blur' }],
        province_name: [{ required: true, message: '请填写', trigger: 'blur' }],
        is_private: [{ required: true, message: '请填写', trigger: 'blur' }],
        sales_region_small: [{ required: true, message: '请填写', trigger: 'blur' }],
        sales_region_small_no: [
          {
            required: true,
            validator: (rule, value, callback) => {
              callback()
            },
            trigger: 'blur',
          },
        ],
        ref_sales_region_small: [{ required: true, message: '请填写', trigger: 'blur' }],
        cat_sales_region_small: [{ required: true, message: '请填写', trigger: 'blur' }],
        sales_region_large: [{ required: true, message: '请填写', trigger: 'blur' }],
        Category: [{ required: true, message: '请填写', trigger: 'blur' }],
        level: [{ required: true, message: '请填写', trigger: 'blur' }],
        // crystal_position_code: [{ required: true, message: '请选择', trigger: 'blur' }],
        // facility_position_code: [{ required: true, message: '请选择', trigger: 'blur' }],
        // ref_crrstal_position_code_string: [{ required: true, message: '请选择', trigger: 'blur' }],
        // cat_crystal_position_code_string: [{ required: true, message: '请选择', trigger: 'blur' }],
        cat_Group: [{ required: true, message: '请填写', trigger: 'blur' }],
        ref_Group: [{ required: true, message: '请填写', trigger: 'blur' }],
        GB32100_2015: [{ required: true, message: '请填写', trigger: 'blur' }],
        IsContainsEyes: [{ required: true, message: '请填写', trigger: 'blur' }],
        license_life: [{ required: true, message: '请填写', trigger: 'blur' }],
        business_life: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    cancalReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs
          const { select1 } = this.$refs
          const { select2 } = this.$refs
          const { select3 } = this.$refs
          const input = select.$el.querySelector('.el-input__inner')
          const input1 = select1.$el.querySelector('.el-input__inner')
          const input2 = select2.$el.querySelector('.el-input__inner')
          const input3 = select3.$el.querySelector('.el-input__inner')
          input.removeAttribute('readonly')
          input1.removeAttribute('readonly')
          input2.removeAttribute('readonly')
          input3.removeAttribute('readonly')
        }
      })
    },
    btn_clear_img(e) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          for (var i in this.file_ist) {
            if (this.file_ist[i] == e) {
              this.file_ist.splice(i, 1)
            }
          }
        })
        .catch(() => {})
    },
    ref_Group_change(e) {
      this.RefGroup_list.find((item) => {
        if (item.Name === e) {
          this.form.cat_Group = item.Name
          this.form.cat_Group_Code = item.Code
          this.form.ref_Group_Code = item.Code
        }
      })
    },
    cat_Group_change(e) {
      console.log(e)
      this.CatGroup_list.find((item) => {
        if (item.Name === e) {
          this.form.ref_Group = item.Name
          this.form.ref_Group_Code = item.Code
          this.form.cat_Group_Code = item.Code
        }
      })
    },
    btn_up_YX(e) {
      window.open('/api/' + e)
    },
    fapiao_blur(e) {
      console.log(this.form)
      if (this.$route.query.type == 'ADD') {
        var name = JSON.parse(JSON.stringify(this.form.Name))
        this.form.invoice_name = name
      }
    },
    btn_up_2(e) {
      // console.log(this.form.file_urls)
      //preview.51i.cc/onlinePreview?url=https://stg-jdp.51i.cc/flie/082915561111e2ff1ef57cc73cd3da78d464b58e2.png&watermarkTxt=MasterData
      https: window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://' + location.host + '/' + e))
    },
    btn_up_1_yl(e) {
      // window.open(" https://view.officeapps.live.com/op/embed.aspx?src="+location.host+"/" + e)
      // if(this.validate(e) == ".doc" || this.validate(e) == ".docx" || this.validate(e) == ".xls" || this.validate(e) == ".xlsx" || this.validate(e) == ".ppt"|| this.validate(e) == ".pptx"){
      //   window.open("https://view.officeapps.live.com/op/embed.aspx?src="+location.host+"/" + e)
      // }else{https://preview.51i.cc/onlinePreview?url=
      window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://share.51i.cc/' + e))
      // }
    },
    cat_large_small_change(e) {
      //   console.log(e)
      if (e == null || e == undefined) {
        return
      }
      this.form.cat_large_small = this.form.cat_sales_region_list = e
      //   console.log(e.length)
      //  return
      if (e.length == 4) {
        this.form.cat_sales_region_small = e[3]
        this.form.cat_sales_region_large = e[2]
      } else if (e.length == 3) {
        this.form.cat_sales_region_small = e[2]
        this.form.cat_sales_region_large = e[2]
      } else if (e.length == 2) {
        this.form.cat_sales_region_small = e[1]
        this.form.cat_sales_region_large = e[1]
      } else if (e.length == 1) {
        this.form.cat_sales_region_small = e[0]
        this.form.cat_sales_region_large = e[0]
      }
    },
    ref_large_small_change(e) {
      if (e == null || e == undefined) {
        return
      }
      console.log(e)
      this.form.ref_large_small = this.form.ref_sales_region_list = e
      //   console.log(e.length)
      //  return
      if (e.length == 4) {
        this.form.ref_sales_region_small = e[3]
        this.form.ref_sales_region_large = e[2]
      } else if (e.length == 3) {
        this.form.ref_sales_region_small = e[2]
        this.form.ref_sales_region_large = e[2]
      } else if (e.length == 2) {
        this.form.ref_sales_region_small = e[1]
        this.form.ref_sales_region_large = e[1]
      } else if (e.length == 1) {
        this.form.ref_sales_region_small = e[0]
        this.form.ref_sales_region_large = e[0]
      }
    },
    large_small_change(e) {
      if (e == null || e == undefined) {
        return
      }
      console.log(e)
      this.form.large_small = this.form.RIDList = e
      console.log(e.length)
      //  return
      if (e.length == 4) {
        this.form.sales_region_small = e[3]
        this.form.sales_region_large = e[2]
      } else if (e.length == 3) {
        this.form.sales_region_small = e[2]
        this.form.sales_region_large = e[2]
      } else if (e.length == 2) {
        this.form.sales_region_small = e[1]
        this.form.sales_region_large = e[1]
      } else if (e.length == 1) {
        this.form.sales_region_small = e[0]
        this.form.sales_region_large = e[0]
      }
    },
    btn_up_1(e) {
      window.open('/' + e)
    },
    async regionGetRegionTree_fn() {
      const { data } = await regionGetRegionTree()
      this.region_list = data.response
    },
    city_change(e) {
      this.city_list.find((item) => {
        if (item.name === e) {
          this.form.cityid = item.id
          this.cat_large_small_change(item.cat_region_list)
          this.ref_large_small_change(item.ref_region_list)
          //   this.form.ref_large_small = item.car_region_list;
          //   this.form.cat_large_small = item.ref_region_list;
          this.form.ref_crystal_position_code = item.ref_code
          this.form.cat_crystal_position_code = item.cat_code
          this.form.pd_position_code = item.pd_code
          this.form.phaco_position_code = item.phaco_code
          this.form.cdhc_position_code = item.cdhc_code
          if (this.FPC_IF) {
            this.form.facility_position_code = item.ps_code
          }
          // this.city_list = item.children
        }
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt1M = file.size / 1024 / 1024 < 1

      // if (!isJPG) {
      //   this.$message.error('上传文件只能是 JPG 格式!')
      // }
      if (!isLt1M) {
        this.$message.error('上传文件大小不能超过 1MB!')
      }
      return isLt1M
    },
    province_change(e) {
      this.region_list.find((item) => {
        if (item.name === this.form.province_name) {
          this.form.ProvinceID = item.id
          this.city_list = item.children
          console.log(this.form)
          //   var form = JSON.parse(JSON.stringify(this.form.Name))
          //   console.log(form)
          //   this.form.city_id =''
          if (e != 'get') {
            this.form.city_name = ''
          }

          //   this.form = form
          //   console.log(this.form.ProvinceID)
        }
      })
    },
    async crystal_position_code_chage(e) {
      const { data } = await EmployeePosition_QueryList({
        code: e,
      })
      this.crystal_position_code_options = data.response
      console.log(this.HospitalName_options)
      console.log(data)
    },
    onBack() {
      this.$router.push({
        path: this.$route.query.back_url,
        query: {
          filters_list: this.$route.query.filters_list,
        },
      })
      // this.$router.push(this.$route.query.back_url);
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    // 审批接口
    approval_request_Puts() {
      console.log(this.approval_request_Put_Material_list)
      HcoApproval(this.approval_request_Put_Material_list).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.$router.push(this.$route.query.back_url)
          // this.dialogVisible =false
          // this.getDetails()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    turn_approvals() {
      this.approval_request_Put_Material_list.approvalstate = false
      this.approval_request_Puts()
    },
    submit_approvals() {
      if (this.request_list.isadmin) {
        if (!this.approval_request_Put_Material_list.data.BWAcctNumber) {
          this.$message({
            message: '请输入ZCN编号',
            type: 'error',
          })
          return
        }
      }
      this.approval_request_Put_Material_list.approvalstate = true
      this.$confirm('确认同意？')
        .then((_) => {
          this.approval_request_Puts()
        })
        .catch((_) => {})
    },
    // 审核进度
    approval_request_Get(id) {
      let para_s = {}
      para_s = {
        approval_data_id: this.$route.query.approval_data_id,
        tag: 'hco',
      }
      approval_requestGetApprovalInfoByID(para_s).then((res) => {
        if (res.data.response) {
          let num_zt = 0
          for (var i in res.data.response.ApprovalDataInfoList) {
            if (res.data.response.ApprovalDataInfoList[i].adireason == 0) {
              num_zt++
            }
          }
          if (res.data.response.state == '-1') {
            this.description_text = res.data.response.reason
          }
          this.num_zt = num_zt
          this.request_list = res.data.response
          console.log(res.data.response.old_value)
          console.log(1)

          if (res.data.response.old_value) {
            // this.old_value = JSON.parse(res.data.response.old_value)
            if (res.data.response.state == -1) {
              this.old_value = res.data.response.new_value_data
              this.old_value_titile = '修改值'
            } else {
              this.old_value = res.data.response.old_value_data
              this.old_value_titile = '原值'
            }
            this.OLD_IF = true
            this.old_value.file_urls == null ? (this.old_value.file_urls = '') : ''
            if (this.old_value.file_urls) {
              this.file_urls_list = this.old_value.file_urls.split(',')
            }
            console.log(this.old_value)
          }
          //   this.form.BWAcctNumber = 888
          if (res.data.response.isadmin) {
            this.approval_request_Put_Material_list.data.BWAcctNumber = this.form.BWAcctNumber
          }
        }
      })
    },
    async save2() {
      var { data } = await HcoUpdataHCOTagInfo(this.form)
      if (data.status == 200) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        // this.$router.push(this.$route.query.back_url)
        this.onBack()
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
    },
    async save(formName) {
      if (
        !this.form.crystal_position_code &&
        !this.form.facility_position_code &&
        !this.form.ref_crystal_position_code &&
        !this.form.cat_crystal_position_code
      ) {
        this.$message({
          message: '晶体销售岗位号、CD临床应用发展岗位号、REF销售岗位号、飞白设备销售岗位号至少填写一个',
          type: 'error',
        })
        return
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.form.file_urls = this.file_ist.toString()
          if (this.$route.query.type == 'ADD') {
            var { data } = await HcoAddHCO(this.form)
          } else {
            var { data } = await HcoUpdataHCO(this.form)
          }
          if (data.status == 200) {
            this.$message({
              message: data.msg,
              type: 'success',
            })
            // this.$router.push(this.$route.query.back_url)
            this.onBack()
          } else {
            this.$message({
              message: data.msg,
              type: 'error',
            })
          }
        } else {
          return
        }
      })
    },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    beforeRemove(file, fileList) {
      console.log(file)
      console.log(fileList)
      return this.$confirm(`确定移除 ${file.name}？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        for (var i in this.file_ist) {
          if (this.file_ist[i] == file.response.response) {
            this.file_ist.splice(i, 1)
          }
          console.log(this.file_ist)
        }
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      })
      // .catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消删除'
      //   });
      // });
    },
    handleSuccess(file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.file_ist.push(file.response)
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
      }
    },
    ExportAccount() {
      let para = this.filters
      HcoHcoExportExcel(para).then((res) => {
        window.location.href = res.data.msg
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    validate(e) {
      var filename = e
      var index1 = filename.lastIndexOf('.')
      var index2 = filename.length
      // alert(index2);
      var type = filename.substring(index1, index2)
      return type
    },
    //获取用户列表
    async getDetails() {
      //   console.log(this.$route.query.id)
      await this.regionGetRegionTree_fn()
      HcoGetByid({ id: this.$route.query.id, tag: this.$route.query.type }).then((res) => {
        this.form = res.data.response
        if (!res.data.response.BWAcctNumber && res.data.response.status == '-1' && this.$route.query.type == 'EDIT') {
          this.HCO_IF = 'ADD'
          this.BCXX_IF = true
          if (this.BU_IF == '晶体事业部') {
            this.BU_IF_REF_CAT = false
          }
          if (this.BU_IF == '飞秒激光及眼表事业部') {
            this.BU_IF_SB_JT = false
          }
        }
        this.province_change('get')
        this.form.large_small = this.form.RIDList
        this.form.cat_large_small = this.form.cat_sales_region_list
        this.form.ref_large_small = this.form.ref_sales_region_list
        // this.province_change()
        // this.form_list.files = this.file_ist.toString()
        // res.data.response.file_urls = '1.png,2.png,3.png,4.png,5.png'
        res.data.response.file_urls == null ? (res.data.response.file_urls = '') : ''
        if (res.data.response.file_urls) {
          this.file_ist = res.data.response.file_urls.split(',')
        }
        console.log(this.form)
        console.log(res.data.response)
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async EmployeeRegionGetEmployeeRegionTrees_fn() {
      const { data } = await EmployeeRegionGetEmployeeRegionTrees()
      this.Employee_list = data.response
    },
    async HcoGetHcoCatGroup_fn() {
      const { data } = await HcoGetHcoCatGroup()
      this.CatGroup_list = data.response
    },
    async HcoGetHcoRefGroup_fn() {
      const { data } = await HcoGetHcoRefGroup()
      this.RefGroup_list = data.response
    },
  },
  async mounted() {
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    var user_details = JSON.parse(window.localStorage.getItem('user'))
    var user_RoleNames = user_details.RoleNames
    //  var GLY_IF = user_RoleNames.filter(function (e) {return e.name == "管理员";}).length != 0
    const { data } = await Employee_GetCurrentEmployee()
    this.BU_IF = data.response.BU
    if (data.response.BU == '晶体事业部') {
      if (this.$route.query.type == 'ADD') {
        this.BU_IF_REF_CAT = false
      }
    }
    if (data.response.BU == '飞秒激光及眼表事业部') {
      if (this.$route.query.type == 'ADD') {
        this.BU_IF_SB_JT = false
      }
    }
    if (this.$route.query.type == 'ADD') {
      if (!data.response.facility_position_code) {
        // this.form.facility_position_code
        this.FPC_IF = true
      }
      data.response.invoice_name = ''
      data.response.city_name = ''
      delete data.response.status
      this.form = data.response
      this.form.Name = ''
      //   this.form.city_name = '111'
      console.log(this.form)

      // this.form.invoice_name = ''
      // this.form.facility_position_code = data.response.facility_position_code
      // this.form.ref_crystal_position_code = data.response.ref_crystal_position_code
      // this.form.cat_crystal_position_code = data.response.cat_crystal_position_code
      // this.form.large_small =
      this.large_small_change(data.response.region_list)
    }
    this.regionGetRegionTree_fn()
    this.EmployeeRegionGetEmployeeRegionTrees_fn()
    this.HcoGetHcoCatGroup_fn()
    this.HcoGetHcoRefGroup_fn()
    this.crystal_position_code_chage()
    // this.$route.query.approval_data_id = 1
    if (this.$route.query.type == 'EDIT' && this.$route.query.status == 'BCXX') {
      // console.log()
      this.BCXX_IF = false
    }
    if (this.$route.query.type != 'ADD') {
      this.getDetails()
    }
    if (this.$route.query.type == 'CK') {
      if (this.$route.query.status == 'HBSC') {
        this.HBSC_IF = false
        console.log(
          user_RoleNames.filter(function (e) {
            return e == '管理员'
          }).length != 0,
        )
        console.log(user_RoleNames)
        this.GLY_IF =
          user_RoleNames.filter(function (e) {
            return e == '管理员'
          }).length != 0
      }
      this.approval_request_Get(this.$route.query.id)
      //   if(user_RoleNames.filter(function (e) {return e == "BU";}).length != 0){
      //     // if(this.$route.query.type != 'CK'){
      //         this.BU_IF_REF_CAT = false
      //     // }
      //   }
    }
  },
}
</script>

<style scoped>
.yz_cls {
  padding-left: 30px;
  padding-top: 8px;
  font-size: 14px;
  color: rgb(233, 119, 88);
}
.demo-input-suffix {
  display: inline-block;
  margin-right: 15px;
}
.demo-input-suffix > .el-input {
  width: 150px;
  margin-bottom: 20px;
}

.el-select,
.el-date-editor,
.el-cascader {
  width: 100% !important;
}
/* .el-form-item__error {
    top: 19% !important;
    right: -29% !important;
 } */
.el-form-item {
  margin-bottom: 10px !important;
}
/* .myClass>.el-cascader-panel>.el-scrollbar:first-child(1)>.el-cascader-menu__wrap>ul>li>.el-radio { 
    display: none !important
  } */
::v-deep .el_upload_hide .el-upload--picture-card {
  display: none !important;
}
</style>
<style>
::v-deep .el_upload_hide .el-upload--picture-card {
  display: none !important;
}
.myClass > .el-cascader-panel > .el-scrollbar:first-child > .el-cascader-menu__wrap > ul > li > .el-radio {
  display: none !important;
}
.myClass > .el-cascader-panel > .el-scrollbar:nth-child(2) > .el-cascader-menu__wrap > ul > li > .el-radio {
  display: none !important;
}
div.el-form-item__error {
  position: absolute !important;
  top: 80% !important;
}
</style>
